var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.users),function(user){return _c('el-tag',{key:user.id},[_vm._v(" "+_vm._s(user.displayName)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }